export var SENTRY_RELEASE = "5b930f992820368b773090a1f1f35ee3a0772580";
